import React from 'react';
import { compose } from 'recompose';
import '../../../utils/styles/Mire.css';
import '../../../utils/styles/header.css';
import { bindActionCreators } from 'redux';
import * as authenticationActions from '../../../actions/authentication';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getLoginInformation, getRefusal, getAttemptError } from '../../../selectors/authentication';
import BeforeLogin from './BeforeLogin';
import AfterLogin from './AfterLogin';
import LoginRefusal from '../../../widgets/LoginRefusal';
import HiaFooter from '../../../widgets/HiaFooter';

import './index.css';

// ID login box. Rendering is driven by the state only: a refusal replaces the form (with
// "Recommencer"), a pending challenge shows the response form, otherwise the login form.
const Component = ({ actions, loginInformation, refusal, attemptError }) => {
    let content;
    if (refusal) {
        content = <LoginRefusal refusal={refusal} onRestart={actions.resetAuth} />;
    } else if (loginInformation && loginInformation.isPublicPass === false) {
        content = <AfterLogin actions={actions} loginInformation={loginInformation} attemptError={attemptError} />;
    } else {
        content = <BeforeLogin actions={actions} />;
    }
    return (
        <div id="mire">
            <div className="mireContainer">
                <div className="mireLogoBox">
                    <img src="/showroom.png" alt="HIAsecure" className="mireLogo" />
                </div>
                <p className="mireTitle">Se connecter</p>
                {content}
                <HiaFooter />
            </div>
        </div>
    );
};

const actions = {
    validateLogin: authenticationActions.validateLogin,
    checkChallenge: authenticationActions.checkChallenge,
    setRefusal: authenticationActions.setRefusal,
    resetAuth: authenticationActions.resetAuth,
};

const mapStateToProps = createStructuredSelector({
    loginInformation: getLoginInformation,
    refusal: getRefusal,
    attemptError: getAttemptError,
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
});
export const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(Component);
